import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

import type { EventId } from './MODAL_EVENT_ID';
import { EVENT_ID } from './MODAL_EVENT_ID';
import { ErrorBoundary } from 'react-error-boundary';

const InstructorCouponModalWrapper = lazy(
  () => import('../components/InstructorCouponModal/InstructorCouponModal')
);
const IntegratedCertificationModal = lazy(
  () => import('../components/IntegratedCertificationModal/IntegratedCertificationModal')
);
const SettlementModalWrapper = lazy(
  () => import('../components/SettlementModal/SettlementModal')
);

export const routes: (RouteObject & { eventId?: EventId })[] = [
  {
    path: '/instructor/coupons',
    element: (
      <ErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <InstructorCouponModalWrapper />
        </Suspense>
      </ErrorBoundary>
    ),
    eventId: EVENT_ID.INSTRUCTOR_COUPON_MODAL,
  },
  {
    path: '/course/:slug',
    element: (
      <ErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <IntegratedCertificationModal />
        </Suspense>
      </ErrorBoundary>
    ),
    eventId: EVENT_ID.INTEGRATED_CERTIFICATION_MODAL,
  },
  {
    path: '/mentors/:id/edit',
    element: (
      <ErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <SettlementModalWrapper />
        </Suspense>
      </ErrorBoundary>
    ),
    eventId: EVENT_ID.SETTLEMENT_MODAL,
  },
  {
    path: '*',
    element: null,
  },
];
